import { ApprovalQueueList, useApprovalQueue } from '@/frontend/components/approvals/ApprovalQueue'
import { SectionLabel } from './SectionLabel'
import type { ApprovalItem } from './types'

interface Props {
  items: ApprovalItem[]
}

// Fila human-in-the-loop na home (SZ-1599/C.4): aprovações pendentes (e
// adiadas vencidas) da organização com ações inline otimistas — Aprovar,
// Adiar (+4h) e Recusar. O contador do label é a pill warn-soft do protótipo
// e segue a lista visível: um item resolvido some (e desconta) na hora.
export function NeedsYou({ items }: Props) {
  const queue = useApprovalQueue(items, 'home_feed')
  const count = queue.visibleItems.length

  return (
    <section aria-label="Precisa de você" className="space-y-2">
      <SectionLabel>
        Precisa de você
        {count > 0 && (
          <span className="rounded-full bg-warning/13 px-2 py-px text-[10.5px] text-warning dark:bg-warning/15">
            {count}
          </span>
        )}
      </SectionLabel>
      {count === 0 ? (
        <p className="text-sm text-muted-foreground">Zero pendências. Aproveite o sossego.</p>
      ) : (
        <ApprovalQueueList queue={queue} />
      )}
    </section>
  )
}
